import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';

export const StyledCard = styled.div`
    padding: ${({ theme: { space } }) => space[7]};
    background: ${({ theme: { colors } }) => colors.neutral__light__10};
    min-height: auto;
    height: 100%;
    ${breakpointUp.md`
        min-height: 500px;
    `}
`;

export const CardContent = styled.div`
    flex-grow: 1;
`;
